/* Auto-generated swatch manifest.
   Regenerate by running the PowerShell command in the theme docs
   whenever swatches are added or renamed. */
SC.swatchManifest = {
  "A01":"A01-Wildwood Duck Egg Fabric Sample.jpg",
  "A02":"A02-Wildwood Ivory Fabric Sample.jpg",
  "A03":"A03-Wildwood Twig Fabric Sample.jpg",
  "A04":"A04-Peony Summer Sky.jpg",
  "A05":"A05-Midsummer Sky Fabric Sample.jpg",
  "A06":"A06-Midsummer Stone Fabric Sample.jpg",
  "A07":"A07-Midsummer Faded Blue Fabric Sample.jpg",
  "A08":"A08-Otter Denim Fabric Sample.jpg",
  "A09":"A09-Pelham Clementine Fabric Sample.jpg",
  "A10":"A10-Pelham Moss Fabric Sample.jpg",
  "A11":"A11-Pelham Denim Fabric Sample.jpg",
  "A12":"A12-Pelham Peacock Fabric Sample.jpg",
  "A13":"A13-Las Salinas 4 Fabric Sample.jpg",
  "B01":"B01-Beatrice Barley Fabric Sample.jpg",
  "B02":"B02-Beatrice Camelia Fabric Sample.jpg",
  "B03":"B03-Beatrice Midnight Fabric Sample.jpg",
  "B04":"B04-Beatrice Nutmeg Fabric Sample.jpg",
  "B05":"B05-Beatrice Olive Fabric Sample.png",
  "C01":"C01-Berrington Fabric Sample.jpg",
  "D01":"D01-Fuchsia Fabric Sample.jpg",
  "D03":"D03-Alchemilla Fabric Sample.jpg",
  "D06":"D06-Designers Guild Cerise Fabric Sample.jpg",
  "D07":"D07-Designers Guild Chalk Fabric Sample.jpg",
  "D08":"D08-Designers Guild Putty Fabric Sample.jpg",
  "G01":"G01-Nympheus Teal-Green Fabric Sample.jpg",
  "G02":"G02-Nympheus Stone-Pistachio Fabric Sample.jpg",
  "G03":"G03-Nympheus Aqua-Teal Fabric Sample.jpg",
  "G04":"G04-Magnolia Cream Blue Fabric Sample.jpg",
  "G05":"G05-Little Magnolia Pink Orange Fabric Sample.jpg",
  "G06":"G06-Little Magnolia Espresso Fabric Sample.jpg",
  "G07":"G07-Little Magnolia Emerald Fabric Sample.jpg",
  "J01":"J01-Boho Cloud Fabric Sample.webp",
  "J02":"J02-Boho Denim Fabric Sample.png",
  "J03":"J03-Boho Parchment Fabric Sample.webp",
  "J04":"J04-Bruges Navy Fabric Sample.jpg",
  "J05":"J05-Bruges Sage Fabric Sample.jpg",
  "J06":"J06-Bruges Sand Fabric Sample.jpg",
  "J07":"J07-Suzy Olive Fabric Sample.jpg",
  "J08":"J08-Suzy Denim Fabric Sample.jpg",
  "J09":"J09-Suzy Natural Fabric Sample.jpg",
  "J10":"J10-Beauville Spring Green Fabric Sample.jpg",
  "J11":"J11-Beauville Cornish Blue Fabric Sample.jpg",
  "L01":"L01-English Garden - Kitty - Spring Green Fabric Sample.jpg",
  "L02":"L02-English Garden - Kitty - Blue Green Fabric Sample.jpg",
  "L03":"L03-English Garden - Kitty - Indian Summer Fabric Sample.jpg",
  "L04":"L04-English Garden - Albertine - Grey Skies Fabric Sample.jpg",
  "L05":"L05-English Garden - Albertine - Classic Rose Fabric Sample.jpg",
  "L06":"L06-English Garden - Albertine - Coral Orange Fabric Sample.jpg",
  "L07":"L07-Belleville - Miji - Juniper Fabric Sample.jpg",
  "L09":"L09-Carnelian Fabric Sample.jpg",
  "L10":"L10-Pastel Blue Fabric Sample.jpg",
  "L11":"L11-Lagoon Fabric Sample.jpg",
  "L12":"L12-Rosewood Fabric Sample.jpg",
  "L13":"L13-Winter Moss Fabric Sample.jpg",
  "L14":"L14-Pine Fabric Sample.jpg",
  "L15":"L15-Grass Fabric Sample.jpg",
  "L16":"L16-Pillar Box Fabric Sample.jpg",
  "L17":"L17-Parakeet Fabric Sample.jpg",
  "L18":"L18 Cerulean Fabric Sample.jpg",
  "L19":"L19-Hemp Fabric Sample.jpg",
  "L20":"L20-Midnight Fabric Sample.jpg",
  "L21":"L21-Sage Fabric Sample.jpg",
  "O01":"O01-Coastal Blue Fabric Sample.jpg",
  "O02":"O02-Petunia Fabric Sample.jpg",
  "O03":"O03-Woodland Stripe Fabric Sample.jpg",
  "O04":"O04-Caramel Stripe Fabric Sample.jpg",
  "O05":"O05-Sea Holly Fabric Sample.jpg",
  "O06":"O06-Garden Grey Fabric Sample.jpg",
  "O07":"O07-Dandelion Fabric Sample.jpg",
  "O08":"O08-Spring Green Fabric Sample.jpg",
  "O09":"O09-Cornish Blue Fabric Sample.jpg",
  "O10":"O10-Narrow Chocolate Stripe Fabric Sample.jpg",
  "O11":"O11-Chocolate Stripe Fabric Sample.jpg",
  "O13":"O13-Cool Coconut Fabric Sample.jpg",
  "O14":"O14-Snow Drop Fabric Sample.jpg",
  "O15":"O15-Sea Salt Fabric Sample.jpg",
  "O16":"O16-Rosedale Fabric Sample.jpg",
  "O17":"O17-Inkspot Fabric Sample.jpg",
  "O18":"O18-Evergreen Fabric Sample.jpg",
  "O19":"O19-Marigold Fabric Sample.jpg",
  "O20":"O20-Potting Moss Fabric Sample.jpg",
  "O21":"O21-Roselette Fabric Sample.jpg",
  "O22":"O22-Sunflower Fabric Sample.jpg",
  "O23":"O23-Pinstripe Natural Fabric Sample.jpg",
  "O24":"O24-Pinstripe Petunia Fabric Sample.jpg",
  "O25":"O25-Pinstripe Nutmeg Fabric Sample.jpg",
  "O26":"O26-Tasman Natural Fabric Sample.jpg"
};
/* CDN base for swatches */
SC.swatchCdnBase = 'https://cdn.sophieconran.com/swatches';

/* Helper: get swatch URL by fabric code */
SC.getSwatchUrl = function(code) {
  if (!code || !SC.swatchManifest[code]) return null;
  return SC.swatchCdnBase + '/' + encodeURIComponent(SC.swatchManifest[code]);
};